import { Expose } from "class-transformer";
import type { CmsProduct } from "../../../../services/ApiClientBonusxCmsRepository/entities/cms-product/cms-product.entity";
import { Product } from "../product/product.entity";
import type { IProductWithCmsData } from "./product-with-cms-data.entity.interface";

export class ProductWithCmsData extends Product implements IProductWithCmsData {
  @Expose()
  cms!: CmsProduct;
}
